import { useEffect, useState } from "react";
import { IChairModalProps } from "../types/modal";

import { useAppDispatch } from "../hooks/redux";
import { closeModalById, openModal } from "../features/modals";

import { useFormik } from "formik";
import axios from "axios";

import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
  TextField,
  Stack,
  Autocomplete,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

import chairSchema, { ChairBase } from "../schemas/chair";
import PermissionGuard from "../components/PermissionGuard";
import PERMISSIONS from "../constants/permissions";
import MODALS from "../constants/modals";
import { Controller, useForm } from "react-hook-form";
import { ClinicResponse } from "../types/clinic";

const ChairModal: React.FunctionComponent<IChairModalProps> = ({
  id,
  callback,
  initialValues,
}) => {
  const dispatch = useAppDispatch();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [clinics, setClinics] = useState<ClinicResponse[]>([]);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      _id: initialValues?._id || undefined,
      name: initialValues?.name || "",
      clinic: initialValues?.clinic._id || "",
    },

    // @ts-ignore
    // resolver: yupResolver(chairSchema),
  });

  const onSubmit = handleSubmit((values) => {
    setIsSubmitting(true);
    axios
      .put("/classifiers/chairs", values)
      .then(() => {
        callback();
        handleClose();
      })
      .catch((err) => {
        console.log("err:", err);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  });

  useEffect(() => {
    axios
      .get<ClinicResponse[]>("/clinics")
      .then((res) => {
        setClinics(res.data);
      })
      .catch((err) => {
        console.log("err:", err);
      });
  }, []);

  const handleDelete = (id: string) => {
    setIsDeleting(true);
    axios
      .delete(`/classifiers/chairs/${id}`)
      .then(() => {
        callback();
        handleClose();
      })
      .catch((err) => {
        console.log("err:", err);
        setIsDeleting(false);
      });
  };

  const handleClose = () => {
    dispatch(closeModalById(id));
  };

  const handleEnterKeyDown = (event: React.KeyboardEvent) => {
    // if (event.key === 'Enter') {
    //   handleSubmit();
    // }
  };

  return (
    <Dialog fullWidth={true} maxWidth="xs" open={true} onClose={handleClose}>
      <form onSubmit={onSubmit}>
        <DialogTitle>
          {initialValues ? "Labot" : "Pievienot"} krēslu
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <Controller
              name="clinic"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  options={clinics}
                  getOptionLabel={(option) => option.name}
                  value={
                    clinics.find((clinic) => field.value === clinic._id) || null
                  }
                  onChange={(event, newValue) => {
                    setValue("clinic", newValue?._id ?? "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Klīnika"
                      error={Boolean(errors.clinic)}
                      helperText={errors.clinic?.message}
                    />
                  )}
                />
              )}
            />
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Nosaukums"
                  error={Boolean(errors.name)}
                />
              )}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <PermissionGuard permission={PERMISSIONS.DELETE_CHAIRS}>
            {({ hasAccess }) => (
              <>
                {hasAccess && initialValues ? (
                  <LoadingButton
                    loading={isDeleting}
                    onClick={() => {
                      dispatch(
                        openModal({
                          type: MODALS.Approve,
                          title: "Vai tiešām dzēst krēslu?",
                          message:
                            "Krēsls un visi tā saistītie dati tiks dzēsti!",
                          onApprove: () => {
                            handleDelete(initialValues._id);
                          },
                        })
                      );
                    }}
                    color="error"
                    variant="outlined"
                  >
                    Dzēst
                  </LoadingButton>
                ) : null}
              </>
            )}
          </PermissionGuard>

          <Stack direction="row" spacing={2} justifyContent="flex-end" flex={1}>
            <Button onClick={handleClose}>Atcelt</Button>
            <LoadingButton
              disabled={isDeleting}
              loading={isSubmitting}
              type="submit"
              variant="contained"
            >
              {initialValues ? "Saglabāt" : "Pievienot"}
            </LoadingButton>
          </Stack>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default ChairModal;
